import React, { FunctionComponent } from "react"
import { Controller, useFormContext } from "react-hook-form"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import {
  ARTIFACT_TAG_TYPE,
  ARTIFACT_TAG_MATERIALS,
} from "../../../api/Definitions"
import TextToSpeech from "../../../components/TextToSpeech/TextToSpeech"
import Upload from "../../../components/Upload/Upload"

interface iProps {
  onCreateAudio?: (data: any) => void
}

const ArtifactOverview: FunctionComponent<iProps> = ({ onCreateAudio }) => {
  const { watch } = useFormContext()
  const { description, descriptionAudio } = watch([
    "description",
    "descriptionAudio",
  ])
  return (
    <div className="scrollable container">
      <div className="row">
        <div className="col-6">
          <FormInput name="title" label="Title" />
          <AsyncCreatableTag
            name="objectType"
            group={ARTIFACT_TAG_TYPE}
            label="Object type"
            isMulti={false}
          />
          <FormInput name="museumNumber" label="Museum number" />
          <FormInput name="culture" label="Culture" />
          <FormInput name="period" label="Period" />
          <AsyncCreatableTag
            name="materials"
            group={ARTIFACT_TAG_MATERIALS}
            isMulti={true}
            label="Materials"
          />
        </div>
        <div className="col-6">
          <Controller as={Textarea} name="description" label="Description" />
          {!descriptionAudio && (
            <TextToSpeech
              text={description}
              onCreate={(data) => {
                console.log(data)
                onCreateAudio && onCreateAudio(data)
              }}
            />
          )}
          <Controller
            name="descriptionAudio"
            render={({ value }) => (
              <Upload
                name="descriptionAudio"
                fileCollection="Files_TextToSpeech"
                maxFiles={1}
                initialFiles={[value || ""]}
                label="Description Audio"
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default ArtifactOverview
